import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class OrganizationTypeService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	// organization Types
	getOrganizationTypes(payload) {
		return this._http.get(`${this.baseUrl}/organizations/types/`, { params: payload.params });
	}

	addOrganizationTypes(payload) {
		return this._http.post(this.baseUrl + '/organizations/types/', payload.body);
	}

	updateOrganizationTypes(payload) {
		return this._http.put(`${this.baseUrl}/admin/organization_types/${payload.optionTypeId}/`, payload.body);
	}

	deleteOrganizationTypes(payload) {
		return this._http.delete(`${this.baseUrl}/organizations/types/${payload.optionTypeId}/`);
	}
}
